import React, { useRef } from 'react';

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"

import { PageProps } from "gatsby";

import ExpandCard from '../../../components/expands/card.expand';
import PricingSectionML from '../../../components/eCommerce/mercadolibre/pricing.section';

import './mercadolibre.scss';
import FadeInAnimationWrapper from '../../../components/animations/FadeInAnimationWrapper';
import { MercadolibreImage } from '../../../images/mercadolibre/mercadolibre.images';
import { CheckIcon } from '../../../images/svg/svg.checkIcon';
import { LogoImage } from '../../../images/logos/logos.images';

const IndexMercadoLibrePage = (props: PageProps) => {
    // Show stamp page instead

    return (
        <Layout {...props}>
            <SEO title="FiscalPOP - Facturación electrónica para vendedores de MercadoLibre"
                description="Envía links de facturación y permite a tus compradores obtener sus facturas, libera tu tiempo y enfócate en tus ventas." />
            <div className='ecommerceDetails ML'>
                <div className='banner'>
                    <div className='bannerText'>
                        <h2>Facturación eCommerce</h2>
                        <h1>MercadoLibre</h1>
                    </div>
                    <div className='backgrounds'>
                        <div className='logoMix'>
                            <LogoImage file='logoIcon' />
                        </div>
                        <div className='circle' />
                        <div className='patterns'>
                            <LogoImage file='circlePatterns' />
                        </div>
                    </div>
                </div>
                <div className='content'>
                    <FadeInAnimationWrapper intersectionThreshold={0.2}>
                        <div className='facturaRapida'>
                            <div className='text'>
                                <h1>
                                    Facturación<br /> rápida y automática
                                </h1>
                                <p>
                                    Permite a tus clientes obtener un link para facturar por mensaje o por correo sin invertir tu tiempo.
                                </p>
                                <p>
                                    ¡Para todo tamaño de vendedores!
                                </p>
                            </div>
                            <div className='image'>
                                <MercadolibreImage file='facturaRapido' />
                            </div>
                        </div>
                    </FadeInAnimationWrapper>

                    <FadeInAnimationWrapper intersectionThreshold={0.2}>
                        <div className='featureChecks'>
                            <div className='featureImage'>
                                <MercadolibreImage file='interface' />
                            </div>
                            <div className='featureList'>
                                <div className='feature'>
                                    <div className='icon'>
                                        <CheckIcon color={'#D1BE14'} />
                                    </div>
                                    <div className='text'>
                                        <p className='title'>
                                            Costo Estático
                                        </p>
                                        <p>
                                            Mismo costo por factura a cliente o por factura global, solamente pagas por lo que usas.
                                        </p>
                                        <p className='bolder'>
                                            No tenemos costos escondidos.
                                        </p>
                                    </div>
                                </div>
                                <div className='feature'>
                                    <div className='icon'>
                                        <CheckIcon color={'#D1BE14'} />
                                    </div>
                                    <div className='text'>
                                        <p className='title'>
                                            Automatización de Facturación
                                        </p>
                                        <p>
                                            Envía links de facturación y permite a tus compradores obtener sus facturas, libera tu tiempo y enfócate en tus ventas.
                                        </p>
                                        <p className='bolder'>
                                            Devoluciones, notas de crédito y facturas globales se pueden emitir automáticamente.
                                        </p>
                                    </div>
                                </div>
                                <div className='feature'>
                                    <div className='icon'>
                                        <CheckIcon color={'#D1BE14'} />
                                    </div>
                                    <div className='text'>
                                        <p className='title'>
                                            Soporte vía correo incluído
                                        </p>
                                        <p>
                                            Tratamos a todos nuestros clientes por igual para brindarles el mejor y más eficiente servicio.
                                        </p>
                                        <p className='bolder'>
                                            Buscamos que seas atendido el mismo día, en menos de 1 día, si es posible.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeInAnimationWrapper>
                    <FadeInAnimationWrapper intersectionThreshold={0.2}>
                        <div className='sectionTitle'>
                            <h1>¿Cómo funciona?</h1>
                            <p>
                                Emite facturas desde tu dashboard y permite a tus clientes facturar por medio de links de auto-facturación.
                            </p>
                        </div>
                        <div className='sellerInterface'>
                            <div className='text'>
                                <h2>Vendedores</h2>
                                <p>
                                    Permite a tus clientes obtener un link para facturar por mensaje o por correo sin invertir tu tiempo.
                                </p>

                                <ExpandCard color="yellow" step={1} title="Configura tu perfil">
                                    <ol>
                                        <li>
                                            <p>
                                                Sube tus certificados y completa tu información fiscal.
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                Personaliza tu perfil subiendo tu logotipo y seleccionando claves del SAT default.
                                            </p>
                                        </li>
                                    </ol>
                                </ExpandCard>
                                <ExpandCard color="yellow" step={2} title="Activa facturación por link">
                                    <ol>
                                        <li>
                                            <p>
                                                Al configurar enviar link de autofacturación, tus clientes recibirán el link para obtener su factura al momento de pagar o recibir el producto.
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                En ventas  donde MercadoLibre no permite iniciar mensajes, tus compradores recibirán su link al mandarte mensaje.
                                            </p>
                                        </li>
                                    </ol>
                                </ExpandCard>
                                <ExpandCard color="yellow" step={3} title="Comienza a facturar" initExpanded={true}>
                                    <ol>
                                        <li>
                                            <p>
                                                Los pedidos facturados que hayan sido cancelados generarán notas de crédito o cancelaran la factura automáticamente.
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                Las Facturas globales se podrán generar automáticamente al final del mes.
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                Siempre podrás tener control manual de tu facturación cuando lo desées.
                                            </p>
                                        </li>
                                    </ol>
                                </ExpandCard>
                            </div>
                            <div className='image'>
                                <MercadolibreImage file='sellerInterface' />
                            </div>
                        </div>
                        <div className='buyerInterface'>
                            <div className='image'>
                                <MercadolibreImage file='buyerInterface' />
                            </div>
                            <div className='text'>
                                <h2>Compradores</h2>
                                <p>
                                    Una interfaz sencilla y fácil de usar para que tus clientes puedan facturar de manera rápida y sencilla.
                                </p>

                                <ExpandCard color="yellow" step={4} title="Concluye la compra">
                                    <ol>
                                        <li>
                                            <p>
                                                El cliente recibirá el link de facturación por mensaje, sin importar que sea pedido FULL
                                            </p>
                                        </li>
                                    </ol>
                                </ExpandCard>
                                <ExpandCard color="yellow" step={5} title="Obtiene su factura">
                                    <ol>
                                        <li>
                                            <p>
                                                Solo se solicitarán los datos necesarios y su correo para emitir la factura.
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                Aquellos que hayan facturado anteriormente tendrán su RFC disponible y podrán obtener su factura en 2 clicks.
                                            </p>
                                        </li>
                                    </ol>
                                </ExpandCard>
                            </div>
                        </div>

                    </FadeInAnimationWrapper>

                    <FadeInAnimationWrapper intersectionThreshold={0.2}>
                        <div className='howToStart'>
                            <div className='text'>
                                <h1>Cómo Comenzar</h1>
                                <p>
                                    El administrador de la cuenta de vendedor deberá configurar la cuenta para poder facturar.
                                </p>
                                <p>
                                    Solo es necesario conectar FiscalPOP a MercadoLibre y configurar tu perfil de Emisor. No es necesario realizar pago alguno para empezar.
                                </p>
                                <div className='_cardBoxes'>
                                    <div className='card'>
                                        <p className='title'>
                                            Facturación
                                        </p>
                                        <p>
                                            Configura tu perfil de emisor y activa la facturación por link.
                                        </p>
                                    </div>
                                    <div className='card'>
                                        <p className='title'>
                                            Carga tu CSD
                                        </p>
                                        <p>
                                            Carga tu certificado de sello digital y tu llave privada para crear tu primera factura.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="image">
                                <MercadolibreImage file='howToStart' />
                            </div>
                        </div>
                    </FadeInAnimationWrapper>


                </div>
            </div>

            <PricingSectionML />
        </Layout >
    )
}

export default IndexMercadoLibrePage
